// One-tap note templates for logging a call fast. Tapping a chip appends the
// label to the note so staff can still add a detail before saving.
export const CALL_NOTE_TEMPLATES = [
  "Left voicemail",
  "Scheduling",
  "Callback requested",
  "Spoke with family",
  "Billing question",
  "Wrong number",
  "No answer",
  "Resolved",
];

// Append a template to existing note text with a clean separator.
export function appendNoteTemplate(current, template) {
  const base = (current || "").replace(/\s+$/, "");
  if (!base) return template;
  if (/[;.]$/.test(base)) return `${base} ${template}`;
  return `${base}; ${template}`;
}
